class Bounds {
    constructor(x, y, w, h) {
        this.x = x;
        this.y = y;
        this.width = w;
        this.height = h;

        Object.seal(this);
    }

    set(x, y, w, h) {
        this.x = x;
        this.y = y;
        this.width = w;
        this.height = h;

        return this;
    }

    get left() { return this.x; }
    get top() { return this.y; }
    get right() { return this.x + this.width; }
    get bottom() { return this.y + this.height; }

    freeze({ width: vpWidth, height: vpHeight }) {
        const x = this.x || 0;
        const y = this.y || 0;
        const width = this.width || vpWidth;
        const height = this.height || vpHeight;

        return Object.freeze({
            x, y, width, height,
            left: x, right: x + width,
            top: y, bottom: y + height
        });
    }
}

export default Bounds;
export { Bounds };